export function clonePollDelay(retryAfterSeconds: number | null, failures: number): number {
  const base = Math.max(2000, Math.min(30000, (retryAfterSeconds ?? 5) * 1000));
  return Math.min(30000, base * 2 ** Math.min(Math.max(failures, 0), 4));
}

type PollToken = { generation: number; jobId: string };

export class ClonePollGate {
  private generation = 0;
  private inFlight: PollToken | null = null;

  nextRequest() { this.generation += 1; }
  currentGeneration() { return this.generation; }

  start(jobId: string, generation = this.generation): PollToken | null {
    if (generation !== this.generation) return null;
    if (this.inFlight?.generation === this.generation && this.inFlight.jobId === jobId) return null;
    const token = { generation: this.generation, jobId };
    this.inFlight = token;
    return token;
  }

  isCurrent(token: PollToken) {
    return token.generation === this.generation && this.inFlight === token;
  }

  finish(token: PollToken) {
    if (this.inFlight === token) this.inFlight = null;
  }
}
